import { render, staticRenderFns } from "./LanguageSelectorDropdown.vue?vue&type=template&id=0dc24f11"
import script from "./LanguageSelectorDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports